import { Component, OnInit, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatDrawer } from '@angular/material/sidenav';
import { ActivatedRoute, Router } from '@angular/router';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { Store } from '@ngrx/store';
import { AppState, selectAuthState, selectUtilsState } from 'app/store/app.states';
import { EstatusEmpresa } from 'app/shared/enum.shared';
import { MostrarSpinner, OcultarExcepcion, OcultarSpinner } from 'app/store/actions/utils.action';
import { CoalService } from 'app/services/coal.service';
import { GuidedTourService } from 'ngx-guided-tour';

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrls: ['./perfil.component.scss'],

})
export class PerfilComponent implements OnInit, OnDestroy {
  @ViewChild('drawer') drawer: MatDrawer;
  drawerMode: 'over' | 'side' = 'side';
  drawerOpened: boolean = true;
  panels: any[] = [];
  selectedPanel: string = 'account';
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  getStateAuthentication;
  authentication;
  getStateOperation;
  operation;
  idEmpresa: number;
  idEmpresas: number[];
  status: number;
  places: any[] = [];
  tourConfig;
  showTour: boolean = false;

  private Observable$ = new BehaviorSubject<any>(null);
  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _fuseMediaWatcherService: FuseMediaWatcherService,
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private coalService: CoalService,
    private tour: GuidedTourService,
    private _router: Router,
  ) {
    this.getStateAuthentication = this.store.select(selectAuthState);
    this.getStateOperation = this.store.select(selectUtilsState);

    this.Observable$.pipe(takeUntil(this._unsubscribeAll))
    .subscribe(res => {
      this.ngOnInit();
    })

    this.tourConfig = {
      tourId: 'test-tour',
      nextText: 'Siguiente',
      steps: [
        {
          content: 'Configura los datos fiscales para tu empresa.',
          title: 'Datos de Facturación',
          selector: '#elementaccount',
          orientation: 'right',
          action: () => {
            this.goToPanel('account')
          }
        },
        {
          content: 'Carga los sellos digitales de tu empresa.',
          title: 'Sellos Digitales',
          selector: '#elementstamp',
          orientation: 'right',
          action: () => {
            this.goToPanel('stamp')
          }
        },
        {
          content: 'Agrega un lugar de expedición.',
          title: 'Lugares de expedición',
          selector: '#elementplace',
          orientation: 'right',
          action: () => {
            this.goToPanel('place')
          }
        },
        {
          content: 'Puedes agregar series a tu lugar de expedición (Opcional).',
          title: 'Series',
          selector: '.dx-button-has-text',
          orientation: 'top',
          action: () => {
            this.goToPanel('place')
          }
        }

        
     ]
    };
  }
    
  ngOnInit(): void {

    this.authentication = this.getStateAuthentication.subscribe((stateAuthentication) => {
    });
    
    this.operation = this.getStateOperation.subscribe((stateOperation) => {
      this.idEmpresa = stateOperation?.empresaSeleccionada?.id;
      this.status = stateOperation?.empresaSeleccionada?.attributes?.ope_empresa_estatus_hs?.data[0]?.attributes?.ope_empresa_estatus?.data?.id;
      if (!this.idEmpresa)
        this.goToPanel('account');
    });
    this.route.queryParams.subscribe(params => {
      if(this.idEmpresa && params.key){
        this.goToPanel(params.key);
      }
    });

    this.getCompanyStatuses();


    this._fuseMediaWatcherService.onMediaChange$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(({ matchingAliases }) => {

          // Set the drawerMode and drawerOpened
          if (matchingAliases.includes('lg')) {
              this.drawerMode = 'side';
              this.drawerOpened = true;
          }
          else {
              this.drawerMode = 'over';
              this.drawerOpened = false;
          }

          // Mark for check
          this._changeDetectorRef.markForCheck();
      });
  }

  reiniciaTour() {
    this.tour.startTour(this.tourConfig);
  }

  configureData() {
    this.showTour = (this.status == EstatusEmpresa.Prerregistro || this.status == EstatusEmpresa.RegistroCompleto || this.places.length == 0);
    
    this.panels = [
      {
          id: 'account',
          icon: 'heroicons_outline:user-circle',
          title: 'Datos de facturación',
          description: 'Administra tus datos personales y datos de facturación.',
          pending: this.status == EstatusEmpresa.Prerregistro
      },
      {
          id: 'stamp',
          icon: 'heroicons_outline:user-circle',
          title: 'Sellos digitales',
          description: 'Administra tus archivos de facturación.',
          pending: (this.status == EstatusEmpresa.Prerregistro || this.status == EstatusEmpresa.RegistroCompleto)
      },
      {
          id: 'place',
          icon: 'heroicons_outline:map',
          title: 'Lugar de expedición',
          description: 'Administra tus lugares de expedición.',
          pending: this.places.length == 0
      },
      {
        id: 'bank',
        icon: 'heroicons_outline:currency-dollar',
        title: 'Cuentas de banco',
        description: 'Administra tus datos de bancos.'
      },
      {
          id: 'observacion',
          icon: 'heroicons_outline:tag',
          title: 'Observaciones',
          description: 'Administra tus observaciones.'
      },
      {
          id: 'newEmpresa',
          icon: 'heroicons_outline:office-building',
          title: 'Nueva Empresa',
          description: 'Administra tus empresas.'
      },
      {
        id: 'plan-billing',
        icon: 'heroicons_outline:credit-card',
        title: 'Folios',
        description: 'Administra tu suscripción y los paquetes de folios.'
      },
      {
        id: 'team',
        icon: 'heroicons_outline:user-group',
        title: 'Equipo',
        description: 'Administra a tu equipo de trabajo.'
      },
      {
          id: 'security',
          icon: 'heroicons_outline:lock-closed',
          title: 'Seguridad',
          description: 'Administra tu contraseña.'
      },
     
    ]  
  }

  getCompanyStatuses () {
    this.store.dispatch(MostrarSpinner());
    this.coalService.getService(`ope-empresas?filters[id]=${this.idEmpresa}&populate=ope_direccion_empresas`)
    .subscribe((res: any) => {
      if( res.data.length == 0 ){
          this._router.navigate(['/cuenta/nonecompany']);
          localStorage.setItem('nonecompany', 'none')
      }
      else {
        // localStorage.setItem('nonecompany', 'true')
        // this._router.navigate(['/factura/facturas/0/0/0/0/0/0/0/0']);
      }


      this.places = res.data[0]?.attributes?.ope_direccion_empresas.data;
      this.store.dispatch(OcultarSpinner());
      this.configureData();
    }, (error: any) => {
      this.store.dispatch(OcultarSpinner());
    })
  }
  ngOnDestroy(): void {
    this._unsubscribeAll.next(false);
    this._unsubscribeAll.complete();
    this.authentication.unsubscribe();
    this.operation.unsubscribe();
  }

  goToPanel(panel: string): void {
    this.selectedPanel = panel;
    console.log("this.selectedPanel", this.selectedPanel);


    // Close the drawer on 'over' mode
    if (this.drawerMode === 'over') {
        this.drawer.close();
    }
}

  getPanelInfo(id: string): any {
    return this.panels.find(panel => panel.id === id);
  }

  trackByFn(index: number, item: any): any {
    return item.id || index;
  }
     
}
